import { MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-barber-surface border-t border-barber-gold/20 py-14">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid sm:grid-cols-3 gap-10">
        <div>
          <img
            src="/barber-parlor-logo.png"
            alt="The Barber Parlor"
            className="h-16 w-auto mb-4"
          />
          <p className="text-barber-muted text-sm leading-relaxed">
            Worcester's classic barbershop. Precision cuts and hot towel shaves, done right.
          </p>
        </div>
        <div className="text-sm text-barber-muted space-y-2">
          <h4 className="font-heading text-barber-gold text-base mb-3">Contact</h4>
          <p className="flex items-start gap-2">
            <MapPin className="w-4 h-4 text-barber-gold mt-0.5" /> 170 Prescott St Ste 2, Worcester, MA 01605
          </p>
          <a href="tel:+17742322759" className="flex items-center gap-2 hover:text-barber-gold transition-colors">
            <Phone className="w-4 h-4 text-barber-gold" /> (774) 232-2759
          </a>
        </div>
        <div className="text-sm text-barber-muted">
          <h4 className="font-heading text-barber-gold text-base mb-3">Hours</h4>
          <p>Tue – Thu: 9 AM – 5 PM</p>
          <p>Fri – Sat: 8 AM – 5 PM</p>
          <p>Sun &amp; Mon: Closed</p>
          <Link
            to="/admin/login"
            data-testid="footer-admin-link"
            className="inline-block mt-6 text-xs uppercase tracking-widest text-barber-muted/60 hover:text-barber-gold transition-colors"
          >
            Barber Login
          </Link>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-10 pt-6 border-t border-barber-gold/10 text-xs text-barber-muted/60">
        © {new Date().getFullYear()} The Barber Parlor. All rights reserved.
      </div>
    </footer>
  );
};
